module.exports = __webpack_public_path__ + "images/feature/1023_stats_1-aa29fa9023a9234319e7575a3992b2b4.jpg";